import React, { Component } from 'react';
import Parser from 'html-react-parser'
import { ArrowIcon } from './SVGIcons'

class First extends Component {
  static defaultProps = {
    hidebtn: false
  }

  state = {

  }

  constructor(props) {
    super(props)


  }

  render() {

    const { hidebtn } = this.props
    const data = this.props?.data || {}
    const postavki = data?.postavki || {}

    return (
      <div style={{ backgroundImage: `url('${postavki?.fon}')` }} className='mt-[100px] w-full bg-cover bg-center'>
        <div className='container'>
          <div style={{ backgroundImage: `url('${postavki?.image}')` }} className='bg-bottom bg-no-repeat bg-contain pb-[200px] xl:pb-[407px] pt-[80px] xl:pt-[90px] w-full'>
            <div className='text-center text-title font-normal text-white uppercase leading-none'>
              {Parser(postavki?.title || '')}
            </div>
            <div className='text-white/75 text-base text-center mt-[12px] max-w-[825px] mx-auto leading-none'>
              {Parser(postavki?.text || '')}
            </div>
            {!hidebtn &&
              <div className='w-full flex justify-center mt-[40px] mb-[-60px]'>
                <a href={data?.links?.about} className='cursor-pointer bg-white duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                  <div className='text-base'>О компании</div>
                  <ArrowIcon width={16} height={16} stroke="currentColor" />
                </a>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default First;